import Tasks from 'APP/Tasks';
import Entities from 'STORE';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

export async function editScheduledVoiceMessage(
  groupId: string,
  message: ChatMessage
): Promise<boolean> {
  const inputPanel = Entities.InputPanelsStore.getById(groupId);
  if (!inputPanel) {
    return false;
  }

  const newText = inputPanel.markdownValue.trim();
  const oldPayload = message.payload.toJSON();

  if (message.payload.comment.trim() === newText) {
    Tasks.messaging.clearInputPanel(groupId);
    return false;
  }

  message.payload.comment = newText;
  message.payload.userMentions = Tasks.messaging.getMentionsDataFromText(newText);

  const canEdit = Tasks.messaging.canSendMessage({
    groupId,
    isCheckSlowMode: false,
    isNewMessage: false,
    payload: message.payload,
  });

  if (!canEdit.result) {
    message.payload.comment = oldPayload.comment;
    message.payload.userMentions = oldPayload.userMentions;

    canEdit.error && Tasks.app.showToast(canEdit.error);
    return false;
  }

  await Tasks.messaging.editScheduledMessage({
    message,
    date: new Date(message.serverTime),
  });

  return true;
}
